import React from "react";
import { Radio } from "antd";

export const colors = [
  { backgroundColor: "#ffedd5", borderColor: "#fdba74", hoverBackground: "#fed7aa" },
  { backgroundColor: "#ede9fe", borderColor: "#c4b5fd", hoverBackground: "#ddd6fe" },
  { backgroundColor: "#fce7f3", borderColor: "#f9a8d4", hoverBackground: "#fbcfe8" },
  { backgroundColor: "#fef9c3", borderColor: "#fde047", hoverBackground: "#fef08a" },
  { backgroundColor: "#ccfbf1", borderColor: "#5eead4", hoverBackground: "#99f6e4" },
  { backgroundColor: "#fee2e2", borderColor: "#f87171", hoverBackground: "#fecaca" },
];

export const tableComponents = {
  header: {
    cell: (props) => (
      <th
        {...props}
        style={{
          background: "#fff",
          borderBottom: "1px solid #E5E7EB",
          fontSize: "10px",
          fontWeight: 500,
          color: "#111827",
          padding: "4px 6px",
          height: "28px",
          lineHeight: "14px",
          whiteSpace: "nowrap",
          ...props.style,
        }}
      />
    ),
  },
  body: {
    cell: (props) => (
      <td
        {...props}
        style={{
          borderBottom: "1px solid #F3F4F6",
          fontSize: "11px",
          fontWeight: 400,
          color: "#374151",
          padding: "6px 6px",
          height: "26px",
          lineHeight: "14px",
          whiteSpace: "nowrap",
          ...props.style,
        }}
      />
    ),
  },
};

export const getStockColumns = ({ currenciesList, selectedStockRow, setSelectedStockRow }) => [
  {
    title: "",
    render: (_, row) => <Radio disabled={row.isCurrentStore} checked={selectedStockRow?.key === row?.key} onChange={() => setSelectedStockRow(row)} />,
  },
  {
    title: "Outlet Name",
    dataIndex: "outletName",
    render: (text) => (
      <span
        style={{
          fontWeight: 500,
          fontSize: "12px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: "14px",
        }}
      >
        {text}
      </span>
    ),
  },
  {
    title: "Batch Number",
    dataIndex: "batchNumber",
    render: (text) => (
      <span
        style={{
          fontSize: "12px",
          fontWeight: 400,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {text}
      </span>
    ),
  },
  {
    title: "MRP",
    dataIndex: "mrp",
    key: "mrp",
    render: (v) => (
      <span style={{ fontSize: "12px" }}>
        {currenciesList[0]?.symbolRightSide === "N" ? currenciesList[0]?.currSymbol : ""}
        {Number(v ?? 0).toLocaleString()}
        {currenciesList[0]?.symbolRightSide === "Y" ? currenciesList[0]?.currSymbol : ""}
      </span>
    ),
  },
  {
    title: "Batch Rate",
    dataIndex: "batchRate",
    key: "batchRate",
    render: (v) => (
      <span style={{ fontSize: "12px" }}>
        {currenciesList[0]?.symbolRightSide === "N" ? currenciesList[0]?.currSymbol : ""}
        {Number(v ?? 0).toLocaleString()}
        {currenciesList[0]?.symbolRightSide === "Y" ? currenciesList[0]?.currSymbol : ""}
      </span>
    ),
  },
  {
    title: "Stock",
    dataIndex: "qty",
    align: "center",
    render: (text) => <span style={{ fontSize: "12px", fontWeight: 500, color: "#000" }}>{text}</span>,
  },
  {
    title: "Unit",
    dataIndex: "unit",
    align: "center",
    render: (text) => <span style={{ fontSize: "12px", fontWeight: 400, color: "#666" }}>{text}</span>,
  },
];
